import { render, staticRenderFns } from "./BonusProgramLevelBadge.vue?vue&type=template&id=53a901c6&scoped=true"
import script from "./BonusProgramLevelBadge.vue?vue&type=script&lang=js"
export * from "./BonusProgramLevelBadge.vue?vue&type=script&lang=js"
import style0 from "./BonusProgramLevelBadge.vue?vue&type=style&index=0&id=53a901c6&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53a901c6",
  null
  
)

export default component.exports